// extracted by mini-css-extract-plugin
export default {"Sign_Button":"SignButton_Sign_Button__57u-w","Left_Arrow":"SignButton_Left_Arrow__bNYls"};